var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGoogleLogin = function SvgGoogleLogin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "#ffd7d7",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 6.48c1.69 0 2.83.73 3.48 1.34l2.54-2.48c-1.56-1.45-3.59-2.34-6.02-2.34-3.52 0-6.56 2.02-8.04 4.96l2.91 2.26c.73-2.17 2.75-3.74 5.13-3.74z",
    fill: "#ea4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.64 12.2c0-.74-.06-1.28-.19-1.84h-8.45v3.34h4.96c-.1.83-.64 2.08-1.84 2.92l2.84 2.2c1.7-1.57 2.68-3.88 2.68-6.62z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.88 13.78c-.19-.56-.3-1.16-.3-1.78s.11-1.22.29-1.78l-2.91-2.26c-.61 1.22-.96 2.59-.96 4.04s.35 2.82.96 4.04z",
    fill: "#fbbc05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 21c2.43 0 4.47-.8 5.96-2.18l-2.84-2.2c-.76.53-1.78.9-3.12.9-2.38 0-4.4-1.57-5.12-3.74l-2.91 2.26c1.48 2.94 4.51 4.96 8.03 4.96z",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 3h18v18h-18z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleLogin, _extends({
    svgRef: ref
  }, props));
});
export default "https://static.im-cdn.com/mjc/storefront/Comfort/static/media/GoogleLogin.529e14ee.svg";
export { ForwardRef as ReactComponent };